import {
	EventLabel,
	EventKeys,
	EventCategory,
	EventArgs,
} from '../../../../services/ga-enums-interfaces';
import { EnrollmentContextService } from '../../../hoc/context/enrollment/enrollment-context';
import {
	gaSuccessEventExtensions,
	gaChangeExtensions,
} from './enrollment-ga-events-extensions';

export const gaSuccessEventAdditions = (
	enrollmentCtxt: EnrollmentContextService
) => {
	const email = enrollmentCtxt.getFormField('email')?.value;
	const tcpaConsent = enrollmentCtxt.getFormField('consenttcpa')?.value;
	return {
		[EventKeys.ProfileFormEmailStatus]: email
			? EventLabel.Filled
			: EventLabel.Blank,
		[EventKeys.ProfileFormTcpaConsent]: tcpaConsent ? 'Yes' : 'No',
		...gaSuccessEventExtensions(enrollmentCtxt),
	};
};

export const gaChangeAdditions = (e: Event): EventArgs | undefined => {
	const target = e.target as HTMLInputElement;
	let event: EventArgs | undefined;
	if (target) {
		switch (target.name) {
			case 'consenttcpa':
				event = {
					[EventKeys.EventCategory]: EventCategory.ProfileForm,
					[EventKeys.EventAction]: 'TCPA Consent',
					[EventKeys.EventLabel]: target.checked ? 'Yes' : 'No',
				};
				break;
			case 'bestTimeToConnect':
				event = {
					[EventKeys.EventCategory]: EventCategory.ProfileForm,
					[EventKeys.EventAction]: 'Best Time to Talk',
					[EventKeys.EventLabel]: target.value,
					[EventKeys.ProfileFormBestTimeToTalk]: target.value,
				};
				break;
			default:
				event = gaChangeExtensions(e) || undefined;
		}
	}

	return event;
};
